import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import {
  SelectScenarioContextProvider,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/SelectScenarioContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStepTemplate } from './Template';
import { GoalStrategiesDetailsProvider } from './Content/GoalStrategiesDetailsContext';

export const ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStepContainer = ({
  resource,
}) => {
  const { setPageContentCollection } = usePageContentContext();
  // Since we are in the scenario selection wizard we should submit the current wizard step after we successfully select
  // so that we can navigate forward to the next relevant step
  const onSelectSuccess = async (_) => {
    const updatedColl = await resource.submit();
    await setPageContentCollection(updatedColl);
  };
  return (
    <SelectScenarioContextProvider onSelectSuccess={onSelectSuccess}>
      <GoalStrategiesDetailsProvider>
        <ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStepTemplate resource={resource} />
      </GoalStrategiesDetailsProvider>
    </SelectScenarioContextProvider>
  );
};

ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStepContainer.defaultProps = {
};

ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStepContainer.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStepTemplate;
